<img *ngIf="!isHidden" height="50px" [src]="_domSanitizer.bypassSecurityTrustUrl(loadImage)"/>